const getLangName = (acceptLanguage) => acceptLanguage?.split(",")[0]?.split(";")[0]?.trim().split("-")[0] ?? "en";
const getSingularOrPluralTerm = (value, singular, plural, locale) => {
  const rules = new Intl.PluralRules(locale);
  return rules.select(value ?? 0) === "one" ? singular : plural;
};

export { getLangName, getSingularOrPluralTerm };
